import { onMounted, onUnmounted, ref } from 'vue';
import { KeepAwake } from '@capgo/capacitor-keep-awake';

export function useScreenWakeLock() {
  const isSupported = ref(false);
  const isActive = ref(false);

  const refreshSupport = async () => {
    try {
      const support = await KeepAwake.isSupported();
      isSupported.value = support.isSupported;
    } catch {
      isSupported.value = false;
    }
  };

  const acquire = async () => {
    try {
      await refreshSupport();
      if (!isSupported.value) return false;
      await KeepAwake.keepAwake();
      isActive.value = true;
      return true;
    } catch {
      isActive.value = false;
      return false;
    }
  };

  const release = async () => {
    try {
      await KeepAwake.allowSleep();
    } finally {
      isActive.value = false;
    }
  };

  onMounted(async () => {
    await refreshSupport();
    await acquire();
  });

  onUnmounted(() => {
    release();
  });

  return {
    isSupported,
    isActive,
    acquire,
    release,
  };
}
